<template>
  <v-overlay v-model="overlayModel" class="align-center justify-center">
    <v-progress-circular indeterminate size="100" color="cyan-lighten-3" width="8"></v-progress-circular>
  </v-overlay>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  }
})

const overlayModel = computed(() => props.show)
</script>

<style scoped>
v-overlay {
  position: absolute !important;
  left: 50% !important;
}
</style>
